import React from 'react'
import * as style from './style.module.scss'

const MenuList = React.memo(({ item }) => (
    <li key={item.label} className={style.menuSubItem}>
        <a
            className={style.menuSubLink}
            target={item.target || '_self'}
            href={item.slug === 'home' ? '/' : item.url}
        >
            {item.label}
        </a>
    </li>
))

const MenuSection = React.memo(({ items, label }) => (
    <li key={label} className={style.menuMainItem}>
        <span>{label}</span>
        <ul className={style.menuSubList}>
            {items.map((item) => (
                <MenuList key={`footer-menu-${item.id}`} item={item} />
            ))}
        </ul>
    </li>
))

const FooterMenu = ({ menu }) => (
    <nav className={style.menu}>
        <ul className={style.menuMainList}>
            {menu.map((item) => {
                if (item.childItems.nodes.length > 0) {
                    return (
                        <MenuSection
                            key={`menu-section-${item.id}`}
                            items={item.childItems.nodes}
                            label={item.label}
                        />
                    )
                }
                return null
            })}
        </ul>
    </nav>
)

export default FooterMenu
